import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { AppUI, ExerciseUI } from '@seedlang/state';
import GridWrapper from 'components/learning_path/grid_wrapper';
import WorksheetLabel from 'components/worksheet/worksheet_label';
import PodcastEpisodeThumbnail from 'components/worksheet/podcast_episode_thumbnail';

const LearningPathItem = styled.button`
  position: relative;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;

const ThumbnailContainer = styled.div`
  position: relative;
  border-radius: 15px;
  background: ${props => props.selected ? props.selectedColor : 'white'};
  border: 5px solid ${props => props.selected ? props.selectedColor : 'white'};
  overflow: hidden;
  transition: opacity 0.2s linear;
  
  &:hover {
    opacity: ${props => props.selected ? 1 : 0.75};
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const WorksheetThumbnail = styled.img`
  width: 100%;
  border-radius: 10px;
  border: 5px solid white;
  display: block;
  aspect-ratio: 242 / 140;
  object-fit: cover;
`;

const CompletedOverlay = styled.div`
  position: absolute;
  inset: 0;
  background-image: linear-gradient(
    to right top, 
    rgba(19, 171, 94, 0.53),
    rgba(61, 188, 85, 0.55),
    rgba(95, 205, 72, 0.55),
    rgba(131, 220, 54, 0.55),
    rgba(168, 235, 18, 0.54)
  );
`;

const hqImageUrl = url => {
  if (!url || typeof url !== 'string') return url;
  return url.replace('maxres', 'hq');
};

@observer
class DesktopPath extends React.Component {
  render() {
    if (this.props.worksheets.length === 0) {
      return (<p>No posts found in this learning path.</p>);
    }

    return (
      <GridWrapper>
        {
          this.props.worksheets.map(item => {
            const worksheet = item.worksheet;
            
            return (
              <LearningPathItem
                id={worksheet?.id}
                key={item.id}
                onClick={() => this.props.onWorksheetClick(worksheet?.id)}
              >
                <ThumbnailContainer
                  selected={worksheet?.id === ExerciseUI.worksheetId}
                  selectedColor={AppUI.site.accentColor}
                >
                  <ImageWrapper>
                    <WorksheetLabel
                      type='free'
                      worksheet={worksheet}
                      marginTop='5px'
                    />
                    {worksheet?.progressPercentage === 100 && <CompletedOverlay />}
                    {
                      worksheet?.podcastEpisode ? (
                        <PodcastEpisodeThumbnail
                          worksheet={worksheet}
                          border='5px solid white'
                        />
                      ) : (
                        <WorksheetThumbnail
                          src={hqImageUrl(worksheet?.imageUrl)}
                          alt={worksheet?.name}
                        />
                      )
                    }
                  </ImageWrapper>
                </ThumbnailContainer>
              </LearningPathItem>
            );
          })
        }
      </GridWrapper>
    );
  }
}

export default DesktopPath;